import { Divider, Tab, Tabs } from "@mui/material";
import { Outlet, useMatch, useNavigate } from "react-router";
export default function TabNavs(_ref) {
    var _match$params;
    var routes = _ref.routes, parentPath = _ref.parentPath;
    var navigate = useNavigate();
    var match = useMatch('/:tab?/*');
    var value = match === null || match === void 0 || (_match$params = match.params) === null || _match$params === void 0 ? void 0 : _match$params.tab;
    // useEffect(() => {
    //     if (!value) navigate(`${parentPath}/${routes?.[0]?.path}`)
    // }, [])
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Tabs, {
        autoCapitalize: "off",
        variant: "scrollable",
        scrollButtons: "auto",
        value: value,
        onChange: function (e, newPath) {
            if (newPath)
                navigate(newPath);
        }
        // TabIndicatorProps={{
        //     sx: {
        //         height: '100%', zIndex: 0, borderRadius: 2,
        //         // bgcolor: 'white'
        //     }
        // }}
        ,
        sx: {
            // bgcolor: 'secondary.100',
            // p: 0.5,borderRadius: 2,
            // borderBottom: '1px solid', borderColor: 'secondary.200',
            px: 3
        }
        // indicatorColor="secondary"
        // textColor="secondary"
    }, routes.map(function (r) { /*#__PURE__*/ return React.createElement(Tab, {
        id: r.id,
        value: r.path,
        sx: {
            zIndex: 2
        },
        disableTouchRipple: true,
        label: r.id
    }); })), /*#__PURE__*/ React.createElement(Divider, {
        variant: "fullWidth"
    }), /*#__PURE__*/ React.createElement(Outlet, null));
}
